import { BrowserRouter as Router, Route, Routes } from "react-router-dom";

import pages from "pages";

import Auth from "components/Auth/Auth";
import Global from "components/WonderOrder/Grobal";

const NotFound = () => {
  return <h1>404 NotFound</h1>;
};

const App = function () {
  return (
    <Auth>
      <Global>
        <Router>
          <div className="app">
            <Routes>
              <Route exact path="/" component={pages.top} />
              {Object.keys(pages).map((key) => {
                const Page = pages[key];
                return (
                  <Route
                    key={key}
                    path={`/${key.replace(/_/g, "/")}`}
                    element={<Page />}
                  />
                );
              })}
              <Route component={NotFound} />
            </Routes>
          </div>
        </Router>
      </Global>
    </Auth>
  );
};

export default App;
